import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility/utility";

const initialState = {
  routerKey: null,
  notifTop: true,
};

const routerUpdateKey = (state, action) => {
  return updateObject(state, { routerKey: action.routerKey });
};

const routerNotifTop = (state, action) => {
  return updateObject(state, { notifTop: action.status });
};

const routerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ROUTER_CHOOSE:
      return routerUpdateKey(state, action);
    case actionTypes.ROUTER_NOTIF_TOP:
      return routerNotifTop(state, action);
    default:
      return state;
  }
};

export default routerReducer;
